<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';

const props = defineProps<{
  checked?: boolean;
  label?: string;
  className?: string;
}>();

const emit = defineEmits<{
  (e: 'update:checked', checked: boolean): void;
  (e: 'change', event: Event): void;
}>();

const handleChange = (e: Event) => {
    emit('update:checked', (e.target as HTMLInputElement).checked);
    emit('change', e);
};
</script>

<template>
  <label class="flex items-center space-x-2 cursor-pointer">
    <input
      type="checkbox"
      :checked="checked"
      @change="handleChange"
      :class="`peer h-4 w-4 shrink-0 rounded-sm border border-slate-900 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-slate-900 data-[state=checked]:text-slate-50 ${className || ''}`"
    />
    <span v-if="label" class="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">{{ label }}</span>
  </label>
</template>